import { type FC, useEffect } from 'react'

import { useTopupCheckoutMutation } from 'STORE/endpoints/credits'

import StripeCheckoutFrame from '../PaymentPlansContainer/components/StripeCheckoutFrame'

const CreditsCheckout: FC<{ packageId: string; onComplete: () => void }> = ({
  packageId,
  onComplete,
}) => {
  const [topupCheckout, { data: session = {} }] = useTopupCheckoutMutation()
  const { clientSecret = null } = session

  useEffect(() => {
    void topupCheckout({ packageId, redirectDomain: window.location.origin })
  }, [packageId])

  return <StripeCheckoutFrame clientSecret={clientSecret} onComplete={onComplete} />
}

export default CreditsCheckout
